export const routes = (prefix = `admissions`) => [
    {
        path: `/${prefix}/current-inpatients`,
        name: `${prefix}.current-inpatients.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.current-inpatients.index`,
                PageDescription: "Admissions - Current Inpatients",
            },
        },
    },
];
